import script from "./UsuarioActivacion.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioActivacion.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioActivacion.vue?vue&type=style&index=0&id=888fe4a8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888fe4a8"]])

export default __exports__